module.exports = __webpack_public_path__ + "https://gloprocessor.com/ment/img/bottom.ec5de06b.png";